import { ValidationHelper } from '../../../../helpers';
// Abstract class for all type of layers (base layers and overlay layers)
export class Layer {
    constructor(id, name, url, type) {
        this.id = id;
        this.name = name;
        this.url = url;
        this.type = type;
    }
    /**
     * If the id, name and url properties exist,
     * then return true, otherwise return false.
     * @returns A boolean value. True if all properties exist.
     */
    existProperties() {
        return (ValidationHelper.existProperty(this.id)
            && ValidationHelper.existProperty(this.name)
            && ValidationHelper.existProperty(this.url));
    }
    /**
     * If the name property is a string, and the visible property is a boolean, and the
     * property is a boolean, then return true.
     *
     * @returns The return value is a boolean. True if type properties are ok.
     */
    sameTypeProperties() {
        return (ValidationHelper.sameTypeProperty(this.id, 'string')
            && ValidationHelper.sameTypeProperty(this.name, 'string')
            && ValidationHelper.sameTypeProperty(this.url, 'string'));
    }
    /**
     * If the layer has properties, and the properties are of the same type
     * and the layer has a name, then the layer has properties.
     * @returns a boolean value.
     */
    layerHasProperties() {
        const existProperties = this.existProperties();
        if (!existProperties)
            return false;
        const sameTypeProperties = this.sameTypeProperties();
        if (!sameTypeProperties)
            return false;
        if (this.name === '')
            return false;
        return true;
    }
    /**
     * If the layer doesn't have properties and properties have right type, throw an error.
     */
    validate() {
        const layerHasProperties = this.layerHasProperties();
        if (!layerHasProperties)
            throw new Error(`Layer ${this.name} has an incorrect entering property`);
        return layerHasProperties;
    }
}
//# sourceMappingURL=layer.js.map